module.exports = __webpack_public_path__ + "static/media/nature-bg-1.e193c427.jpg";